import React from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import BaseComponent from "../../../baseComponent.js";
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator.js";
import ColorUtil from "../../../../core/utils/colorUtil.js";
import AppConfig from "../../../../config/config.js";
import styles from "./styles.scss";
import DatasetService from "../../../../core/services/datasetService.js";
import DashboardService from "../../../../core/services/dashboardService.js";
import FunctionDetail from "../../../analytic-studio/spreadsheet/functions/detail/functionDetail.jsx";
import FunctionList from "../../../analytic-studio/spreadsheet/functions/functionList.jsx";
import {functionDetails} from "../../../../core/constants/functionDescription";


export default class FormulaBar extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      functionDetail: null,
      functionAndDatasetList: [],
      argIndex: -1
    }
  }

  componentWillMount() {
    this.keys = {
      backspace: 8,
      tab: 9,
      enter: 13,
      shift: 16,
      ctrl: 17,
      alt: 18,
      esc: 27,
      space: 32,
      left: 37,
      up: 38,
      right: 39,
      down: 40
    };

    this.INSERTION_TYPE = {
      NONE: 0,
      INSERT: 1,
      REPLACE: 2
    };
    this.insertionIndicators = "(,+-*/=";
    this.dataProfileCache = [];
    this.functionAndDatasetList = functionDetails;
    // a cell which has highlighted background
    this.backgroundHighlightedCell = null;
    // set of cells which have highlighted border
    this.highightedCellElements = [];
    this.insertTargetElementIndex = -1;
    this.insertionMode = this.INSERTION_TYPE.NONE;
    // function detail popup style(minimized or not)
    this.minimized = true;
    this.colors = this.props.colors.slice();
  }

  componentWillUpdate(nextProps, nextState) {
    let _this = this;
    if (this.props.expression == nextProps.expression) return;

    let lastSpan = null;

    if (nextProps.expression) {
      // var parsed = this.parseRawFormula(nextProps.expression.value);
      let parsed = this.parseRawFormula(nextProps.expression);
      let spans = this.insertFormulaSpan(parsed, nextProps.mappings);
      lastSpan = spans[spans.length - 1];

      let selection = window.getSelection();
      let $anchorNode = $(selection.anchorNode);

      if ($anchorNode.hasClass("formula-bar")) {
        let range = document.createRange();
        let anchorNodeToMove = null;
        if (this.insertionMode === this.INSERTION_TYPE.REPLACE) {
          anchorNodeToMove = this.refs.formulaBar.childNodes[this.insertTargetElementIndex];
          range.setStartAfter(anchorNodeToMove);
          anchorNodeToMove.classList.add("f-span--replaceable");
        } else if (lastSpan) {
          range.setStartAfter(lastSpan);
        }

        // setting timeout because selection change by clicking cell happens after this manual change
        setTimeout(function () {
          selection.removeAllRanges();
          selection.addRange(range);
        }, 100);
      }
    } else {
      $(this.refs.formulaBar).empty();
    }
  }

  componentDidMount() {
    this.formulaBar = $(this.refs.formulaBar);
    if (this.props.expression) {
      let parsed = this.parseRawFormula(this.props.expression);
      this.insertFormulaSpan(parsed, this.props.mappings);
    }
  }

  toggleContent() {
    this.minimized = !this.minimized;
  }


  handleClick() {
    this.showPopup();
  }

  showPopup() {
    let nodeAtSelection = this.getSelectionContainerElement();
    let spans = this.formulaBar.find("span");
    let indexOfSelectedNode = $(spans).index(nodeAtSelection);
    let closeParenthesesIndex = -1, openParenthesesIndex = -1;

    if (spans.length === 0) {
      this.hidePopup();
      return;
    }

    this.formulaBar.find(".focused").removeClass("focused");
    this.formulaBar.find(".blurred").removeClass("blurred");

    switch (nodeAtSelection.textContent) {
      case "(": {
        openParenthesesIndex = indexOfSelectedNode;
        closeParenthesesIndex = findMatchingCloseParentheses(indexOfSelectedNode);
        break;
      }
      case ")": {
        openParenthesesIndex = findMatchingOpenParentheses(indexOfSelectedNode);
        closeParenthesesIndex = indexOfSelectedNode;
        break;
      }
      default: {
        openParenthesesIndex = findMatchingOpenParentheses(indexOfSelectedNode);
        closeParenthesesIndex = findMatchingCloseParentheses(indexOfSelectedNode);
      }
    }

    // highlight parentheses if found matching
    if (openParenthesesIndex != -1 && closeParenthesesIndex != -1) {
      $(spans[openParenthesesIndex]).addClass("focused");
      $(spans[closeParenthesesIndex]).addClass("focused");
      highlightRange(openParenthesesIndex, closeParenthesesIndex);
    }

    let popupDisplayed = false;
    let functionName = "", argIndex = -1, nextSpan = spans[indexOfSelectedNode + 1];

    // if the next span is "(", the current selection is function
    if (nextSpan && nextSpan.textContent === "(") {
      functionName = spans[indexOfSelectedNode].textContent.trim();
      argIndex = findArgumentIndex(indexOfSelectedNode + 2);
      popupDisplayed = this.showFunctionDetail(functionName, argIndex);
    }

    // if the last character of the current node is ".", try to find data profile
    if (nodeAtSelection.textContent[nodeAtSelection.textContent.length - 1] === ".") {
      let datasetRef = nodeAtSelection.textContent.substr(0, nodeAtSelection.textContent.length - 1);
      let searchResult = this.getFunctionOrDatasetList(datasetRef);
      if (searchResult.length === 1) {
        popupDisplayed = this.showDataProfileDetail(searchResult[0].dataProfileId, datasetRef);
      }
    }

    let split = nodeAtSelection.textContent.split(".");
    if (split.length === 2) {
      let datasetRef = split[0].trim();
      let searchResult = this.getFunctionOrDatasetList(datasetRef);
      if (searchResult.length === 1) {
        popupDisplayed = this.showDataProfileDetail(searchResult[0].dataProfileId, datasetRef, split[1]);
      }
    }

    // show function and dataset list(from inputs)
    if (!popupDisplayed && nodeAtSelection.textContent.length > 0) {
      popupDisplayed = this.showFunctionAndDatasetList(nodeAtSelection.textContent);
    }

    // find function at the cursor and show detail
    if (!popupDisplayed && openParenthesesIndex > 0) {
      functionName = spans[openParenthesesIndex - 1].textContent.trim();
      argIndex = findArgumentIndex(openParenthesesIndex + 1);
      popupDisplayed = this.showFunctionDetail(functionName, argIndex);
    }

    // if nothing to show, hide it
    if (!popupDisplayed) {
      this.hidePopup();
    }

    function findArgumentIndex(startIndex) {
      let index = 0;
      for (let i = startIndex; i < spans.length; i++) {
        let t = spans[i].textContent.trim();
        if (spans[i] === spans[indexOfSelectedNode]) {
          if (t === ",") index++;
          return index;
        } else {
          if (t === "(") {
            // found open parentheses. skip to the end
            i = findMatchingCloseParentheses(i);
          } else if (t === ",") {
            index++;
          }
        }
      }

      // nothing found. highlight the first arg
      return 0;
    }

    function findMatchingOpenParentheses(startIndex) {
      let numCloseParentheses = 0;
      for (let i = startIndex - 1; i >= 0; i--) {
        if (spans[i].textContent === ")") {
          numCloseParentheses++;
        } else if (spans[i].textContent === "(") {
          if (numCloseParentheses === 0) {
            return i;
          } else {
            numCloseParentheses--;
          }
        }
      }

      return -1;
    }

    function findMatchingCloseParentheses(startIndex) {
      let numOpenParentheses = 0;
      for (let i = startIndex + 1; i < spans.length; i++) {
        if (spans[i].textContent === "(") {
          numOpenParentheses++;
        } else if (spans[i].textContent === ")") {
          if (numOpenParentheses === 0) {
            return i;
          } else {
            numOpenParentheses--;
          }
        }
      }

      return -1;
    }

    function highlightRange(start, end) {
      for (let i = 0; i < spans.length; i++) {
        if (i < start - 1 || i > end) {
          $(spans[i]).addClass("blurred");
        }
      }
    }
  }

  hidePopup() {
    this.setState({
      functionAndDatasetList: [],
      functionDetail: null
    })
  }

  // TODO: Remove hard-coded stuff and using the service
  showDataProfileDetail(dataProfileId, ref, searchString) {
    let mockData = JSON.parse('{"persistenceId":"e0c8e869-750c-4b4e-8a46-8d2317622c0e","name":"LpSnapshot","fields":[{"name":"Level 1 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice0"},{"name":"Level 1 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty0"},{"name":"Level 1 Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec0"},{"name":"Level 2 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice1"},{"name":"Level 2 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty1"},{"name":"Level 2 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec1"},{"name":"Level 3 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice2"},{"name":"Level 3 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty2"},{"name":"Level 3 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec2"},{"name":"Level 4 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice3"},{"name":"Level 4 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty3"},{"name":"Level 4 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec3"},{"name":"Level 5 Bid Price","valueType":2,"maxLength":0,"fieldId":"bidPrice4"},{"name":"Level 5 Bid Quantity","valueType":2,"maxLength":0,"fieldId":"bidQty4"},{"name":"Level 5 Bid Price Executable","valueType":7,"maxLength":0,"fieldId":"bidExec4"},{"name":"Level 1 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice0"},{"name":"Level 1 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty0"},{"name":"Level 1 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec0"},{"name":"Level 2 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice1"},{"name":"Level 2 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty1"},{"name":"Level 2 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec1"},{"name":"Level 3 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice2"},{"name":"Level 3 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty2"},{"name":"Level 3 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec2"},{"name":"Level 4 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice3"},{"name":"Level 4 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty3"},{"name":"Level 4 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec3"},{"name":"Level 5 Ask Price","valueType":2,"maxLength":0,"fieldId":"askPrice4"},{"name":"Level 5 Ask Quantity","valueType":2,"maxLength":0,"fieldId":"askQty4"},{"name":"Level 5 Ask Price Executable","valueType":7,"maxLength":0,"fieldId":"askExec4"},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0},{"maxLength":0}],"description":"Structure storing multiple levels of pricing","createdByOrganization":"4cc27103-e155-420b-785a-6a78478b1092","createdByUser":"2b4e3261-6368-5954-7459-58784d6a7444"}');
    let dataProfile = null;
    for (let i = 0; i < this.dataProfileCache.length; i++) {
      if (this.dataProfileCache[i].persistenceId === dataProfileId) {
        dataProfile = this.dataProfileCache[i];
        break;
      }
    }

    let previewList = [];
    if (dataProfile === null) {

      for (let i = 0; i < mockData.fields.length; i++) {
        if (mockData.fields[i].hasOwnProperty("fieldId")) {
          if (searchString) {
            if (mockData.fields[i].fieldId.substr(0, searchString.length) != searchString) continue;
          }
          previewList.push({
            name: mockData.fields[i].fieldId,
            summary: mockData.fields[i].name,
            type: ref
          });
        }
      }

      this.setState({
        functionAndDatasetList: previewList,
        functionDetail: null
      })
    }

    return previewList.length !== 0;
  }

  showFunctionDetail(functionName, argIndex) {
    let fn = this.getFunction(functionName);
    if (fn != null) {
      this.setState({
        functionDetail: fn,
        argIndex: argIndex,
        functionAndDatasetList: []
      });
    }

    return fn !== null;
  }

  showFunctionAndDatasetList(searchText) {
    let list = this.getFunctionOrDatasetList(searchText.trim());
    if (list.length > 0) {
      this.setState({
        functionDetail: null,
        functionAndDatasetList: list
      });
    }

    return list.length !== 0;
  }


  getFunctionOrDatasetList(keyword) {
    let result = [];
    if (keyword.length > 0) {
      for (let i = 0; i < this.functionAndDatasetList.length; i++) {
        let formulaName = this.functionAndDatasetList[i].name.toLowerCase();
        keyword = keyword.toLowerCase();
        if (formulaName.startsWith(keyword)) result.push(this.functionAndDatasetList[i]);
      }
    }
    return result;
  }

  getFunction(fnName) {
    let result = null;
    for (let i = 0; i < this.functionAndDatasetList.length; i++) {
      let name = this.functionAndDatasetList[i].name.toLowerCase();
      fnName = fnName.toLowerCase();
      if (name === fnName) return this.functionAndDatasetList[i];
    }

    return result;
  }

  reset() {
    let replaceable = document.querySelector(".f-span--replaceable");
    if (replaceable) replaceable.classList.remove("f-span--replaceable");
    this.insertionMode = this.INSERTION_TYPE.NONE;
    window.getSelection().removeAllRanges();
    if (this.backgroundHighlightedCell) {
      this.backgroundHighlightedCell.style.background = null;
      this.backgroundHighlightedCell = null;
    }
    this.props.expression.value = "";
    if (this.props.changeInsertMode) {
      this.props.changeInsertMode(false);
    }

    this.hidePopup();
    this.props.updateFormula(this.refs.formulaBar.textContent, false, true);
  }

  resetSpanColors() {
    this.colors = this.props.colors.slice();
  }

  insertFormulaSpan(parsed, mappings) {
    const dashboardVariables = DashboardService.getCurrentDashboardVariables();
    let spanElements = [];
    this.colors = this.props.colors.slice();
    $(this.refs.formulaBar).empty();
    for (let i = 0; i < parsed.length; i++) {
      let content = parsed[i];
      let el = document.createElement("span");

      if (!isNaN(parseFloat(content))) {
        el.classList.add("f-span--numeric");
        el.textContent = content;
      } else {
        let key = content.trim();
        let mapped = false;

        if (mappings.hasOwnProperty(key)) {
          el.textContent = content.replace(key, mappings[key].value);
          mapped = true;
        } else if (dashboardVariables.hasOwnProperty(key)) {
          el.textContent = content.replace(key, dashboardVariables[key].name);
          mapped = true;
        }

        if (mapped) {
          let color = this.colors.shift();
          el.style.color = color;
          el.style.background = ColorUtil.toRgba(color, 0.05);
          el.style.border = "0px dashed " + ColorUtil.toRgba(color, 0.4);
          el.setAttribute("data-color", color);
          el.setAttribute("data-key", key);
        } else {
          el.textContent = content;
        }
      }

      el.classList.add("f-span");
      this.refs.formulaBar.appendChild(el);
      spanElements.push(el);
    }

    return spanElements;
  }

  getLeadingWhiteSpaces(text) {
    let spaces = "";
    for (let i = 0; i < text.length; i++) {
      if (text[i] === " " || text[i] === "\xa0") {
        spaces += " ";
      }
    }
    return spaces;
  }

  parseRawFormula(text) {
    let parsed = text.split(AppConfig.EXPRESSION_REGEX);

    let index = parsed.length;
    while (index--) {
      if (parsed[index] === "") parsed.splice(index, 1);
    }

    let result = [], quote = null, temp = "";
    for (let i = 0; i < parsed.length; i++) {
      if (parsed[i] === "[") {
        quote = '[';
      } else if (parsed[i] === "]") {
        if (quote !== null) {
          temp += parsed[i];
          if (quote == "[") quote = null;
        }
      } else if (parsed[i].indexOf("'") > -1 && parsed[i].match(/'/g).length === 1) {
        if (quote === null) {
          quote = "'";
        } else if (quote === "'") {
          temp += parsed[i];
          quote = null;
        }
      } else if (parsed[i].indexOf('"') > -1 && parsed[i].match(/"/g).length === 1) {
        if (quote === null) {
          quote = '"';
        } else if (quote === '"') {
          temp += parsed[i];
          quote = null;
        }
      }

      if (quote === null) {
        if (temp === "") {
          result.push(parsed[i]);
        } else {
          result.push(temp);
        }
        temp = "";
      } else {
        temp += parsed[i];
      }
    }
    if (temp !== "") result.push(temp);

    return result;
  }

  getSelectionContainerElement() {
    let range, sel, container;
    sel = window.getSelection();
    if (sel.getRangeAt) {
      if (sel.rangeCount > 0) {
        range = sel.getRangeAt(0);
      }
    } else {
      range = document.createRange();
      range.setStart(sel.anchorNode, sel.anchorOffset);
      range.setEnd(sel.focusNode, sel.focusOffset);

      if (range.collapsed !== sel.isCollapsed) {
        range.setStart(sel.focusNode, sel.focusOffset);
        range.setEnd(sel.anchorNode, sel.anchorOffset);
      }
    }

    if (range) {
      container = range.commonAncestorContainer;
      return container.nodeType === 3 ? container.parentNode : container;
    }
  }

  handleKeyUp(e) {
    let _this = this;
    let list = $("#formula-list");
    let options = list.find("li");
    let dataProfileId = null, ref = null;
    switch (e.keyCode) {
      case this.keys.up:
      case this.keys.down: {
        e.preventDefault();
        return false;
      }
      case this.keys.esc: {
        this.reset();
        break;
      }
      case this.keys.right:
      case this.keys.left:
      case this.keys.space: {
        this.showPopup();
        e.preventDefault();
        return false;
      }
      case this.keys.enter:
      case this.keys.shift:
      case this.keys.tab: {
        break;
      }
      default: {
        let anchorNodeToMove = null;
        let prevRange = window.getSelection().getRangeAt(0);
        let prevRangeStartOffset = prevRange.startOffset;
        let prevRangeEndOffset = prevRange.endOffset;
        let spans = this.formulaBar.find("span");
        let parsed = this.parseRawFormula(e.currentTarget.textContent);
        parsed = this.mapFormula(parsed);
        let nodeAtSelection = this.getSelectionContainerElement();
        // somehow, font element is inserted into span
        if (nodeAtSelection.nodeName === "FONT") {
          nodeAtSelection = nodeAtSelection.parentElement;
        }
        // index of the selection span of formula node
        let parsedNodeContent = this.parseRawFormula(nodeAtSelection.textContent);
        // will use this index after re-construct span nodes as the current caret position
        let indexOfSelectedNode = $(spans).index(nodeAtSelection);
        // when formula is empty, the first span element will be created
        // so set index of the selection span to 0
        if (indexOfSelectedNode == -1) indexOfSelectedNode = 0;

        if (parsedNodeContent.length > 1) {
          if ((spans.length - 1 !== indexOfSelectedNode || spans.length === 1) &&
            (parsedNodeContent[0] === " " || parsedNodeContent[0] === "(" || parsedNodeContent[1] === "(")) {
            indexOfSelectedNode += parsedNodeContent.length - 1;
            prevRangeStartOffset = 1;
            prevRangeEndOffset = 1;
          } else {
            indexOfSelectedNode += parsedNodeContent.length - 1;
            prevRangeStartOffset = parsedNodeContent[parsedNodeContent.length - 1].length;
            prevRangeEndOffset = parsedNodeContent[parsedNodeContent.length - 1].length;
          }
        }

        spans = this.insertFormulaSpan(parsed, this.props.mappings);
        anchorNodeToMove = spans[indexOfSelectedNode];

        // this.props.updateFormula(e.currentTarget.textContent, true);

        this.updateExpression(parsed.join(""));

        if (anchorNodeToMove) {
          let selection = window.getSelection();
          let range = document.createRange();
          range.setStart(anchorNodeToMove.firstChild, prevRangeStartOffset);
          range.setEnd(anchorNodeToMove.firstChild, prevRangeEndOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }

        if (dataProfileId) {
          this.showDataProfileDetail(dataProfileId, ref)
        } else {
          this.showPopup(dataProfileId);
        }
      }
    }
  }

  mapFormula(parsed) {
    const dashboardVariables = DashboardService.getCurrentDashboardVariables();
    let fn = [];

    for (let i = 0; i < parsed.length; i++) {
      let content = parsed[i].trim();
      let value = parsed[i];
      for (let key in this.props.mappings) {
        if (this.props.mappings[key] && this.props.mappings[key].value === content) {
          value = parsed[i].replace(this.props.mappings[key].value, key);
          break;
        }
      }

      for (let variableId in dashboardVariables) {
        if (dashboardVariables[variableId].name === content) {
          value = parsed[i].replace(dashboardVariables[variableId].name, variableId);
          break;
        }
      }
      fn.push(value);
    }

    return fn;
  }


  updateExpression(newExpression) {
    let exp = newExpression.replace(/\s/g, " ");
    try {
      this.props.updateExpression("expression", {
        key: this.props.expressionKey,
        expression: exp,
        mappings: Object.assign({}, this.props.mappings)
      });
    } catch (e) {
      console.log(e)
    }

  }

  handleKeyDown(e) {
    let list = $("#formula-list");
    let options = list.find("li");
    let currentOption = options.filter('.selected');
    let currentIndex = options.index(currentOption);

    switch (e.keyCode) {
      case this.keys.enter:
      case this.keys.tab: {
        e.preventDefault();
        return false;
      }
      case this.keys.right:
      case this.keys.left:
      case this.keys.esc:
      case this.keys.backspace: {
        return false;
      }
      case this.keys.up: {
        if (currentIndex > 0) {
          let prevOption = options.eq(currentIndex - 1);
          currentOption.removeClass('selected');
          prevOption.addClass('selected');
          scrollUpIfSelectionIsInvisible();
        }
        e.preventDefault();
        return false;
      }
      case this.keys.down: {
        if (currentIndex != options.length - 1) {
          let prevOption = options.eq(currentIndex + 1);
          options.eq(currentIndex).removeClass('selected');
          prevOption.addClass('selected');
          scrollDownIfSelectionIsInvisible();
        }
        e.preventDefault();
        return false;
      }
    }

    function scrollUpIfSelectionIsInvisible() {
      let currentOption = options.filter('.selected');
      let offsetTop = currentOption.offset().top - list.offset().top;
      if (offsetTop < 0) {
        list[0].scrollTop += offsetTop;
      }
    }


    function scrollDownIfSelectionIsInvisible() {
      let currentOption = options.filter('.selected');
      let offsetTop = currentOption.offset().top - list.offset().top;
      let positionBottom = offsetTop + currentOption.outerHeight();
      let containerHeight = list.height();
      if (containerHeight < positionBottom) {
        list[0].scrollTop += (positionBottom - containerHeight);
      }
    }
  }

  handleDragOver(e) {
    let key = $(e.target).attr("data-key");
    if (key) {
      $(e.target).css("border-width", "1px");
    }
  }

  handleDragLeave(e) {
    $(e.target).css("border-width", "0px");
  }


  handleDrop(e) {

    e.preventDefault();
    let key = $(e.target).attr("data-key");
    let data = JSON.parse(e.dataTransfer.getData('data'));
    e.persist();

    if (data.isDatasetDrop) {
      e.target.textContent = data.value;
      updateMapping(this.props.mappings, data);
      let parsed = this.parseRawFormula(this.refs.formulaBar.textContent);
      parsed = this.mapFormula(parsed);
      this.insertFormulaSpan(parsed, this.props.mappings);
      this.updateExpression(parsed.join(""));
    } else {
      DatasetService.checkUserDatasetSubscription(data.dataset.persistenceId).then(subscriptions => {
        if (subscriptions.length > 0) {
          if (e.target.tagName !== "DIV") {
            if (key != null) {
              e.target.textContent = data.value;
            } else {
              e.target.textContent = data.value + e.target.textContent;
            }
          } else {
            if ($(e.target).find("span:last-child").attr("data-key")) {
              e.target.textContent += ", " + data.value;
            } else {
              e.target.textContent += data.value;
            }
          }
          let key = updateMapping(this.props.mappings, data);
          let parsed = this.parseRawFormula(this.refs.formulaBar.textContent);
          parsed = this.mapFormula(parsed);
          this.insertFormulaSpan(parsed, this.props.mappings);

          // this.props.updateFormula(parsed.join(""), this.props.mappings);
          this.updateExpression(parsed.join(""));
        }
        else {
          this.props.callback(data);
        }
      });
    }

    function updateMapping(mappings, data) {
      for (let key in mappings) {
        if (mappings[key].value === data.value) return null;
      }
      let newKey = UniqueIdGenerator.id();

      if (data.isDatasetDrop) {
        mappings[newKey] = {
          datasetId: data.dataset.persistenceId,
          value: data.value
        };
      } else {
        let value = data.isPreviewWidget ?
          data.field.name : data.dataset.name.replace(/([\+\-\*\/])/g, "_") + " " + data.field.name;
        mappings[newKey] = {
          datasetId: data.dataset.persistenceId,
          fieldId: data.field.fieldId,
          value: value
        };
      }

      return newKey;
    }
  }

  render() {
    let detail = null, list = null, error = this.props.error, errorMessage;
    // todo: enable function detail
    if (this.state.functionDetail) {
      detail = <FunctionDetail key="function-detail"
                               function={this.state.functionDetail}
                               argIndex={this.state.argIndex} minimized={this.minimized}
                               toggleContent={this.toggleContent}/>;
    }

    if (this.state.functionAndDatasetList.length > 0) {
      list = <FunctionList functionAndDatasetList={this.state.functionAndDatasetList}/>;
    }

    if (error) {
      const index = error.indexOf("at character");
      if(index > -1) {
        errorMessage = error.substr(0, index);
      } else {
        errorMessage = error;
      }
    }


    return (
      <div className={styles.formulaBarWrapper}>
        <div className={styles.formulaBar}
             id="formula-bar"
             ref="formulaBar"
             contentEditable="true"
             spellCheck="false"
             tabIndex="0"
             role="combobox"
             aria-labelledby="formula-bar"
             aria-autocomplete="inline"
             aria-owns="formula-list"
             onClick={this.handleClick}
             onKeyDown={this.handleKeyDown}
             onKeyUp={this.handleKeyUp}
             onDragOver={this.handleDragOver}
             onDragLeave={this.handleDragLeave}
             onDrop={this.handleDrop}></div>
        <ReactCSSTransitionGroup transitionName="example"
                                 transitionEnterTimeout={500}
                                 transitionLeaveTimeout={300} component="div">
          {/*{list}*/}
          {
            this.props.error ? <div className={styles.error}>{errorMessage}</div> : null
          }
          {detail}

        </ReactCSSTransitionGroup>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/formulaBar.jsx